import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=0613a098&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports